import { useSaveHotelDiscover as useSaveHotelDiscoverNew } from 'app/hooks/data/core/admin/hotels/useSaveHotelDiscover';
import {
  useSaveHotelDiscover as useSaveHotelDiscoverOld, //   useSaveHotelDiscover,
} from 'app/hooks/data/hotels/useHotelDiscover';

export const useSaveHotelDiscover = ({
  hotelId,
  isLegacy,
}: {
  hotelId: number;
  isLegacy: boolean;
}) => {
  const oldMutation = useSaveHotelDiscoverOld({ hotelId });
  const newMutation = useSaveHotelDiscoverNew({ hotelId });

  return isLegacy ? oldMutation : newMutation;
};
